import script from "./OptionsChangeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptionsChangeModal.vue?vue&type=script&lang=ts&setup=true"

import "./OptionsChangeModal.vue?vue&type=style&index=0&id=e7034870&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1683583046/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7034870"]])

export default __exports__